export enum MultiSendContractMethod {
  SendTokens = 'disperseToken',
  SendTokensSimple = 'disperseTokenSimple',
  SendNative = 'disperseEther'
}
